import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  CREATE_MESSAGE_GROUP_RESET,
  UPDATE_MESSAGE_GROUP_RESET,
} from "../../redux/constants/messageGroups";

import MessageGroupForm from "./MessageGroupForm";
import MessageGroupsList from "./MessageGroupsList";
import Loader from "../Loader";
import Pagination from "../GroupInfo/Pagination";
import {
  deleteMessageGroup,
  getAllMessageGroups,
} from "../../redux/actions/messageGroupSettings";

const MessageGroups = ({ tab, openForm, setOpenForm, handleOpenForm }) => {
  const [selectedMessageGroup, setSelectedMessageGroup] = useState(null);
  const [curpage, setCurpage] = useState(1);

  const dispatch = useDispatch();

  const messageGroupsSettings = useSelector(
    (state) => state.messageGroupsSettings
  );
  // console.log("messageGroupsSettings", messageGroupsSettings);
  const {
    loading,
    messageGroups,
    totalPage,
    successCreate,
    successDelete,
    successUpdate,
    messageGroupCreate,
  } = messageGroupsSettings;

  const limit = 10;
  useEffect(() => {
    dispatch(getAllMessageGroups(limit * (parseInt(curpage) - 1), limit));
  }, [dispatch, curpage]);

  useEffect(() => {
    setCurpage(1);
  }, [tab]);

  useEffect(() => {
    if (successDelete) {
      dispatch(getAllMessageGroups(limit * (parseInt(curpage) - 1), limit));
    }
    if (successCreate) {
      // setOpenForm(false);
      dispatch({
        type: CREATE_MESSAGE_GROUP_RESET,
      });
    }

    if (successUpdate) {
      // setOpenForm(false);
      setSelectedMessageGroup(null);
      dispatch({
        type: UPDATE_MESSAGE_GROUP_RESET,
      });
    }
  }, [
    successDelete,
    successCreate,
    successUpdate,
    dispatch,
    curpage,
    messageGroupCreate,
  ]);

  const handleRemoveMessageGroups = (id) => {
    dispatch(deleteMessageGroup(id));
  };

  return (
    <>
      {loading && <Loader />}
      {openForm && <div className="overlayMain activate"></div>}
      <MessageGroupsList
        data={messageGroups}
        handleRemoveMessageGroups={handleRemoveMessageGroups}
        handleEditMessageGroups={(values) => {
          setSelectedMessageGroup(values);
          setOpenForm(true);
        }}
        handleOpenForm={handleOpenForm}
      />
      {messageGroups?.length > 0 && (
        <Pagination
          setCurpage={setCurpage}
          totalPage={totalPage}
          // page={page}
          page={curpage}
        />
      )}

      {openForm && (
        <div id="tab-4" className="tab-content">
          <MessageGroupForm
            // openForm={openForm}
            selectedMessageGroup={selectedMessageGroup}
            setOpenForm={(val) => {
              setSelectedMessageGroup(null);
              setOpenForm(val);
            }}
          />
        </div>
      )}
    </>
  );
};

export default MessageGroups;
